import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = recipe({
  base: {
    aspectRatio: "9/16",
    backgroundColor: theme.colors.background,
    color: theme.colors.onBackground,
    borderRadius: theme.borderRadiuses.m,
    padding: `${theme.spacings.s} ${theme.spacings.m}`,
  },
  variants: {
    variant: {
      default: {
        backgroundColor: theme.colors.background,
      },
      secondary: {
        backgroundColor: theme.colors.tertiary,
      },
      infoSurface: {
        backgroundColor: theme.colors.tertiary,
      },
      primary50: {
        backgroundColor: theme.colors.tertiary,
      },
      tertiary: {
        backgroundColor: theme.colors.tertiary,
      },
    },
  },
});

export const cameraStyle = style({
  width: "20%",
  aspectRatio: "10/1.5",
  backgroundColor: theme.colors.onBackground,
  borderRadius: theme.borderRadiuses.m,
});

export const timeStyle = style({
  fontSize: `${rem(10)} !important`,
  flexBasis: "20%",
});

export const iconsContainerStyle = style({
  flexBasis: "20%",
  justifyContent: "flex-end",
});

export const screenStyle = style({
  // padding: theme.spacings.s,
});
